// extracted by mini-css-extract-plugin
export default {"picText":"index_picText_Oxi0N","pic":"index_pic_9l25e","text":"index_text_yNNGB","title":"index_title_WBea4","bref":"index_bref_InvQo"};